export default {
  pageTitle: {
    fontSize: 40,
    fontWeight: 400,
  },
};
